export type AuctionVisibilityListing = {
  listing_format?: string | null;
  auction_status?: string | null;
  auction_highest_bidder_id?: string | null;
  auction_highest_bid?: number | null;
  auction_reserve_price?: number | null;
  auction_bid_count?: number | null;
  user_id?: string | null;
};

export const ACTIVE_AUCTION_OR_NON_AUCTION_FILTER =
  "listing_format.neq.auction,auction_status.in.(scheduled,live)";

export function isFinishedAuctionStatus(status: string | null | undefined): boolean {
  const st = String(status ?? "").toLowerCase();
  return st === "ended" || st === "settled" || st === "cancelled";
}

export function isFinishedAuctionListing(listing: AuctionVisibilityListing): boolean {
  return (
    String(listing.listing_format ?? "").toLowerCase() === "auction" &&
    isFinishedAuctionStatus(listing.auction_status)
  );
}

export function isAuctionWinnerViewer(
  listing: AuctionVisibilityListing,
  viewerId: string | null | undefined,
): boolean {
  if (!viewerId) return false;
  if (String(listing.auction_highest_bidder_id ?? "") !== viewerId) return false;

  const bidCount = Number(listing.auction_bid_count ?? 0);
  const highestBid =
    listing.auction_highest_bid != null && Number.isFinite(Number(listing.auction_highest_bid))
      ? Number(listing.auction_highest_bid)
      : null;
  if (bidCount <= 0 && highestBid == null) return false;

  const reserve =
    listing.auction_reserve_price != null &&
    Number.isFinite(Number(listing.auction_reserve_price))
      ? Number(listing.auction_reserve_price)
      : null;
  if (reserve != null && (highestBid == null || highestBid < reserve)) return false;

  return true;
}

export function canViewerSeeFinishedAuction(
  listing: AuctionVisibilityListing,
  viewerId: string | null | undefined,
): boolean {
  if (!isFinishedAuctionListing(listing)) return true;
  if (!viewerId) return false;
  if (viewerId === String(listing.user_id ?? "")) return true;
  return isAuctionWinnerViewer(listing, viewerId);
}

export function isVisibleInDiscoveryFeed(listing: AuctionVisibilityListing): boolean {
  return !isFinishedAuctionListing(listing);
}

export function isVisibleOnSellerProfile(
  listing: AuctionVisibilityListing,
  viewerId: string | null | undefined,
  profileOwnerId: string,
): boolean {
  if (!isFinishedAuctionListing(listing)) return true;
  if (viewerId === profileOwnerId) return true;
  return isAuctionWinnerViewer(listing, viewerId);
}

export function isVisibleInFollowingFeed(
  listing: AuctionVisibilityListing,
  viewerId: string | null | undefined,
): boolean {
  if (!isFinishedAuctionListing(listing)) return true;
  if (!viewerId) return false;
  if (viewerId === String(listing.user_id ?? "")) return true;
  return isAuctionWinnerViewer(listing, viewerId);
}

export function isVisibleInSavedListings(
  listing: AuctionVisibilityListing,
  viewerId: string,
): boolean {
  if (!isFinishedAuctionListing(listing)) return true;
  if (viewerId === String(listing.user_id ?? "")) return true;
  return isAuctionWinnerViewer(listing, viewerId);
}
